"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CATEGORIES_OPTIONS_IDS = exports.SurveyLanguages = void 0;
exports.SurveyLanguages = {
    es: "Spanish",
    fr: "French",
    de: "German",
};
exports.CATEGORIES_OPTIONS_IDS = [
    "demographics",
    "fooddrink",
    "alcohol",
    "clothing",
    "vehicle",
    "entertainment",
];
//# sourceMappingURL=types.js.map